import * as React from "react";
import { Context } from "./_context";
export const NavigationShareAndroidIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M18 0a4 4 0 1 1-2.372 7.22l-6.685 4.114a4.024 4.024 0 0 1 0 1.331l6.685 4.114a4 4 0 1 1-1.572 2.555L7.37 15.22a4 4 0 1 1 0-6.44l6.685-4.115A4 4 0 0 1 18 0Zm0 18.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Zm-13-8a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Zm13-8a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Z", fill: "currentColor" }));
  return iconset[size];
};
NavigationShareAndroidIcon.iconId = "cwICE3";
